export const sxConfig = {
  page: {
    px: {
      xs: 1.5,
      md: 3,
    },
    pt: 2.5,
  },

  cardGridItem: {
    width: {
      xs: '50%',
      md: 350,
    },
    flexBasis: {
      xs: '50%',
      md: 350,
    },
    maxWidth: {
      xs: '50%',
      md: 350,
    },
  },

  card: {
    width: '100%',
    height: {
      xs: 160,
      md: 230,
    },
    p: {
      xs: 1,
      md: 2,
    },
    boxSizing: 'border-box',
    borderRadius: 4,
    cursor: 'pointer',

    display: 'flex',
    flexDirection: 'column',
    gap: {
      xs: 0,
      md: 1,
    },
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    transition: 'transform 300ms ease-in-out, background-color 300ms ease-in-out',
  },

  activityTitle: {
    width: '100%',
    fontSize: {
      xs: '1.25rem',
      md: '1.5rem',
    },
    fontWeight: 700,
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    order: {
      xs: 2,
      md: 1,
    },
  },

  activityIconButton: {
    m: 0,
    p: 0,
    color: 'inherit',
    pointerEvents: 'none',
    mb: {
      xs: 1,
      md: 0,
    },
    order: {
      xs: 1,
      md: 3,
    },
  },

  openReportTimerText: {
    fontVariantNumeric: 'tabular-nums',
    fontWeight: 700,
    fontSize: {
      xs: '1.25rem',
      md: '1.5rem',
    },
    color: '#FFCA28',
  },

  openReportTimer: {
    order: 3,
  },
};
